import { render, staticRenderFns } from "./detials.vue?vue&type=template&id=0b3fdae4&scoped=true&"
import script from "./detials.vue?vue&type=script&lang=js&"
export * from "./detials.vue?vue&type=script&lang=js&"
import style0 from "./detials.vue?vue&type=style&index=0&id=0b3fdae4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b3fdae4",
  null
  
)

export default component.exports